import React, { FC, useState } from 'react';
import { Box, Container, makeStyles, Theme, Typography } from '@material-ui/core';
import { ContentDescription } from 'components/structures/general';
import { QuoteForm } from 'templates/forms';
import { IFields } from '../forms/QuoteForm';
import { RadioGroupComponent } from '../../components/atoms';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
    padding: theme.spacing(14, 0),
    position: 'relative',
    margin: theme.spacing(20, 0),
  },
  title: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(3),
  },
  paragraph: {
    marginBottom: theme.spacing(4),
    color: theme.palette.secondary.light,
  },
  submitButton: {
    '&, &:hover': {
      background: 'none',
      backgroundColor: theme.palette.primary.light,
    },
  },
  radioGroupClass: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(10),
    },
  },
}));

const preferredMethodValues = ['Accept terms of use and conditions'];

const blogFields: Array<IFields> = [
  {
    label: 'Full Name*',
    name: 'fullName',
  },
  {
    label: 'Email Address*',
    name: 'email',
  },
];

const BlogSubscribeForm: FC = () => {
  const classes = useStyles();
  const [preferredMethod, setPreferredMethod] = useState(preferredMethodValues[0]);

  return (
    <Box className={classes.wrapper} id="request-form">
      <Container fixed>
        <ContentDescription title={{ text: 'Subscribe to cms updates', variant: 'h2', className: classes.title }} />
        <Typography className={classes.paragraph} variant="body2">
          We promise to deliver savvy, eye-catching content that’ll conquer your heart or send your brain cogs spinning like
          crazy.
        </Typography>
        <QuoteForm
          useSubscribeValidator
          useGridHalfFields
          apiPath="/api/subscribe-news-form"
          fields={blogFields}
          externalFieldsButtonInline
          externalFields={
            <RadioGroupComponent
              lightTheme
              onChange={setPreferredMethod}
              values={preferredMethodValues}
              value={preferredMethod}
              className={classes.radioGroupClass}
            />
          }
          buttonProps={{ className: classes.submitButton }}
          buttonText="Subscribe"
        />
      </Container>
    </Box>
  );
};

export default BlogSubscribeForm;
